'use client';
import { FC } from 'react';

interface AiFeatureItemProps {
    id: any;
    title: string;
    description: string;
}

const AiFeatureItem: FC<AiFeatureItemProps> = ({ id, title, description }) => {
    return (
        <div className="d-flex align-items-start gap-3">
            <img
                src={`/assets/icons/ai-features/${id}.png`}
                alt={'feature-' + id}
                width={40}
                height={40}
            />
            <div className="flex-1 text-start">
                <h5 className="fw-bold mb-2 sora">{title}</h5>
                <p className="mb-4" style={{ color: '#686869', lineHeight: 1.5 }}>
                    {description}
                </p>
            </div>
        </div>
    );
};

export { AiFeatureItem };
